<div class="sidebar">
  <section class="header">
    <ng-content select="[sidebar-header]"></ng-content>
  </section>
  <section class="body">
    <ng-content select="[sidebar-body]"></ng-content>
  </section>
  <section class="footer">
    <ng-content select="[sidebar-footer]"></ng-content>
  </section>
  <ng-content></ng-content>
</div>
